import { useEffect, useState } from "react";

import { apiPaths } from "../../../../../service/apiPaths";
import ApiService from "../../../../../service/ApiService";

interface IProjectView {
  _id: string;
  name: string;
  description: string;
  status: string;
  totalHours: number;
  users: Array<{
    name: string;
    email: string;
    role: string;
    totalHours: number;
    dateWise: Array<{
      date: string;
      hours: number;
    }>;
  }>;
}

const useViewProject = (projectId: IProjectView) => {
  const [projectData, setProjectData] = useState<IProjectView | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchProjectData = async () => {
      if (!projectId?._id) return;

      setLoading(true);
      try {
        const result = await ApiService({
          method: "GET",
          endpoint: `${apiPaths.getProjectById}/${projectId._id}`,
        });
        setProjectData(result.data);
      } catch (error) {
        console.error("Error fetching project data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjectData();
  }, [projectId?._id]);

  return {
    projectData,
    loading,
  };
};

export default useViewProject;
